var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZambia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#496E2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2609 16H16V32C17.8702 32 19.6651 31.6781 21.3333 31.0884L22.2609 16Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6665 27.9246C29.9395 24.9949 31.9999 20.7383 31.9999 16H25.739L26.6665 27.9246Z",
    fill: "#FF9811"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3342 16V31.0884C23.3215 30.3858 25.1287 29.3021 26.6676 27.9246V16H21.3342Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5651 10.435H25.3911C25.3911 9.66664 24.7682 9.0437 23.9998 9.0437C23.2314 9.0437 22.6085 9.66664 22.6085 10.435H18.4346C18.4346 11.2035 19.1039 11.8263 19.8722 11.8263H19.8259C19.8259 12.5948 20.4487 13.2176 21.2172 13.2176C21.2172 13.9861 21.84 14.609 22.6085 14.609H25.3911C26.1595 14.609 26.7824 13.9861 26.7824 13.2176C27.5508 13.2176 28.1738 12.5948 28.1738 11.8263H28.1274C28.8958 11.8263 29.5651 11.2034 29.5651 10.435V10.435Z",
    fill: "#FF9811"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZambia);
export default __webpack_public_path__ + "static/media/zambia.712fd40c.svg";
export { ForwardRef as ReactComponent };